import BreadCrumbs from "../../../components/common/BreadCrumbs/BreadCrumbs";
import { useNavigate } from "react-router-dom";
import { tuitionManagerPortalTabsData } from "../../../config/tabsConfig";
import Tabs from "../../../components/common/Tabs";
import { trackNavigation } from '../../../services/analytics';
import Notifications from '../../../components/common/Notifications';
import { useAppSelector } from '../../../store/hooks';

const TuitionManagerPortal = () => {
  const navigate = useNavigate();
  const profileError = useAppSelector((state) => state.profile.profileError);
  const handleBreadcrumbPrevious = (): void => {
    console.log('📊 Analytics: Navigate back to tuition from manager portal');
    trackNavigation('tuition-manager-portal', 'tuition', 'back');
    navigate("/tuition");
  };

  if (profileError) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Notifications messageInfo={profileError} status={false} />
      </div>
    );
  }

  return (
    <div className="min-h-screen desktop:mx-40! mx-5!">
      <BreadCrumbs
        previousPage="Back to tuition reimbursement"
        currentPage="Manager portal"
        onPreviousClick={handleBreadcrumbPrevious}
      />
      <div>
        <h1 className="h1 mt-8!">Manager Portal</h1>
      </div>
            <Tabs tabs={tuitionManagerPortalTabsData} />
    </div>
  );
};

export default TuitionManagerPortal;
